<script lang="ts">
	import { getAllMarkets } from '$lib/data/markets';
	import {
		currentMarket,
		fetchingMarkets,
		marketSortDirection,
		marketSortKey,
		markets,
		sortedMarkets
	} from '$lib/home/store';
	import EachMarket from '$lib/portfolio/EachMarket.svelte';
	import { addDollarSign, filterMarketsBasedOnSearch, getNumBackInUnits } from '$lib/util/util';
	import { walletConnected } from '$lib/wallet/store';
	import { onMount } from 'svelte';
	import { goto } from '$app/navigation';
	import MarketSearch from '$lib/home/topInfoSection/MarketSearch.svelte';

	let searchText: string = '';
	$: filteredMarkets = filterMarketsBasedOnSearch($sortedMarkets, searchText);
</script>

<div class="p-2 sm:p-6 flex flex-col items-start w-full sm:hidden">
	<div class="flex-col sm:grid sm:grid-cols-3 sm:gap-5 w-full mt-2">
		<div
			class="border border-fx-grey-600 bg-fx-gradient-8-40 rounded-xl squircle-xl w-full px-4 sm:px-8 sm:py-4 py-2"
		>
			<div class="text-xs text-fx-grey-400">Total Traded Volume (in last 24 hr):</div>

			<div class="flex mt-2 gap-2 items-center">
				{#if $currentMarket}
					<div class="text-fx-grey-100 font-semibold sm:text-2xl text-lg">
						{addDollarSign(getNumBackInUnits($currentMarket.volume24h ?? 0, 18, 2))}
					</div>
				{:else}
					<div class="h-8 w-40 bg-fx-grey-600 animate-pulse rounded-lg squircle-lg" />
				{/if}
			</div>
		</div>
		<div
			class="border border-fx-grey-600 bg-fx-gradient-8-40 rounded-xl squircle-xl w-full px-4 sm:px-8 py-2 sm:py-4 my-2 sm:my-0"
		>
			<div class="text-xs text-fx-grey-400">Open Interest:</div>
			<div class="flex mt-2 gap-2 items-center">
				{#if $currentMarket}
					<div class="text-fx-grey-100 font-semibold sm:text-2xl text-lg">
						{addDollarSign(getNumBackInUnits($currentMarket.openInterest, 18, 2), 3)}
					</div>
				{:else}
					<div class="h-8 w-40 bg-fx-grey-600 animate-pulse rounded-lg squircle-lg" />
				{/if}
			</div>
		</div>
		<div
			class="border border-fx-grey-600 bg-fx-gradient-8-40 rounded-xl squircle-xl w-full px-4 sm:px-8 sm:py-4 py-2"
		>
			<div class="text-xs text-fx-grey-400">Trades (in last 24 hr):</div>

			<div class="flex mt-2 gap-2 items-center">
				{#if $currentMarket}
					<div class="text-fx-grey-100 font-semibold sm:text-2xl text-lg">
						{$currentMarket.trades24h}
					</div>
				{:else}
					<div class="h-8 w-40 bg-fx-grey-600 animate-pulse rounded-lg squircle-lg" />
				{/if}
			</div>
		</div>
	</div>
	<div class="font-semibold text-2lg flex gap-2 w-full my-2">
		<MarketSearch bind:searchText gradientStyle="bg-fx-grey-300 w-[400px]" />
	</div>
	<div class="my-2">
		<button
			class="text-fx-grey-200 text-lg font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
			class:text-fx-white={$marketSortKey == 'volume24h' && $marketSortDirection == 'Descending'}
			on:click={() => {
				$marketSortKey = 'volume24h';
				$marketSortDirection = 'Descending';
			}}>Trending</button
		>
		<button
			class="text-fx-grey-200 text-lg font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
			class:text-fx-white={$marketSortKey == 'change24hPercentage' &&
				$marketSortDirection == 'Ascending'}
			on:click={() => {
				$marketSortKey = 'change24hPercentage';
				$marketSortDirection = 'Ascending';
			}}>Top Losers</button
		>
		<button
			class="text-fx-grey-200 text-lg font-semibold bg-fx-grey-900 rounded-lg squircle-lg px-5 py-1 hover:bg-fx-grey-600 hover:text-fx-grey-100"
			class:text-fx-white={$marketSortKey == 'change24hPercentage' &&
				$marketSortDirection == 'Descending'}
			on:click={() => {
				$marketSortKey = 'change24hPercentage';
				$marketSortDirection = 'Descending';
			}}>Top Gainers</button
		>
	</div>

	<div class="border-t border-t-fx-grey-600 w-full my-2" />
	{#if !$markets && !$fetchingMarkets && $walletConnected}
		<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />

		<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />

		<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />
	{:else if $fetchingMarkets}
		<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />

		<div class="animate-pulse h-20 bg-fx-grey-700 w-full rounded-lg squircle-lg mt-4" />
	{:else if $markets && !$fetchingMarkets}
		{#each filteredMarkets as market}
			<EachMarket {market} />
		{/each}
	{/if}
</div>
